import useUserQuery from "../components/Common/useUserQuery";
import { QueryOptions } from "../components/Common/useQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

import { OptionalAmount } from "../components/Common/dtos/OptionalAmount";

export interface CustomerActivityReportDto {
  ticketNumber: string;
  site: string;
  loadedAt: string;
  orderNumber?: string;
  customerName?: string;
  destination?: string;
  branch?: string;
  driver?: string;
  transport?: string;
  carrier?: string;
  applicator?: string;
  notes?: string;
  productMeasurements: { [productName: string]: OptionalAmount };
}

export interface CustomerActivityReportParams {
  units?: string;
  customerId?: string;
  itemId?: string;
  branchId?: string;
  siteId?: string;
  integrationId?: string;
  startDate?: string;
  endDate?: string;
}

const useGetCustomerActivityReport = (
  params: CustomerActivityReportParams,
  options?: QueryOptions<CustomerActivityReportDto[]>
) => {
  const business = useSelectedBusiness();
   
  return useUserQuery<CustomerActivityReportDto[]>({
    path: formatCustomerActivityReportQuery(business.id, params),
  }, {
    autoQuery: false,
    ...options
  });
}

export const formatCustomerActivityReportQuery = (businessId: string, params: CustomerActivityReportParams, download: boolean = false) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, value.toString());
    }
  });

  var path = `/api/businesses/${businessId}/reports/customerActivity`;

  if (download) {
    path = path.concat("/download");
  }
 
  return `${path}?${urlParams.toString()}`;
}

export default useGetCustomerActivityReport;